module.exports = __webpack_public_path__ + "c3944f88b026dda89b9b6efdb24012dd.gif";